// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-only compact layout for Sales Report tables */

@media (max-width: 768px) {
  .SalesReportTable_tableWrapper__wssaZ {
    margin-left: -4px;
    margin-right: -4px;
  }

  .SalesReportTable_table__iYgdZ th,
  .SalesReportTable_table__iYgdZ td {
    padding: 3px 5px !important;
    font-size: 11px !important;
    line-height: 1.15 !important;
    width: auto !important;
    min-width: 40px !important;
    max-width: 88px !important;
  }

  .SalesReportTable_table__iYgdZ th {
    font-size: 10px !important;
    font-weight: 600;
  }

  /* Actions / wide columns */
  .SalesReportTable_table__iYgdZ td:last-child,
  .SalesReportTable_table__iYgdZ th:last-child {
    max-width: none !important;
    min-width: 56px !important;
  }

  .SalesReportTable_table__iYgdZ button {
    min-width: 22px !important;
    height: 22px !important;
    padding: 0 3px !important;
    font-size: 9px !important;
  }

  .SalesReportTable_table__iYgdZ .SalesReportTable_chakra-stack__wBudX {
    gap: 3px !important;
  }

  .SalesReportTable_pagination__pmM\\+k {
    margin: 8px 0 !important;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center !important;
  }

  .SalesReportTable_paginationControls__Z2YB4 {
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .SalesReportTable_paginationText__NLWud {
    font-size: 11px !important;
    margin-right: 0 !important;
    flex-shrink: 1;
  }

  .SalesReportTable_paginationNav__kOZX4 {
    gap: 4px !important;
  }

  .SalesReportTable_paginationNav__kOZX4 .SalesReportTable_chakra-button__Yw59W {
    min-width: 26px !important;
    height: 26px !important;
  }

  .SalesReportTable_paginationInput__9OdTL .chakra-numberinput {
    width: 52px !important;
  }

  .SalesReportTable_paginationInput__9OdTL {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }

  .SalesReportTable_paginationSelect__TR457 select {
    width: 68px !important;
    font-size: 11px !important;
    height: 28px !important;
    padding: 2px 4px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SalesReportTable.module.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;;IAEE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,QAAQ;IACR,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;AACF","sourcesContent":["/* Mobile-only compact layout for Sales Report tables */\n\n@media (max-width: 768px) {\n  .tableWrapper {\n    margin-left: -4px;\n    margin-right: -4px;\n  }\n\n  .table th,\n  .table td {\n    padding: 3px 5px !important;\n    font-size: 11px !important;\n    line-height: 1.15 !important;\n    width: auto !important;\n    min-width: 40px !important;\n    max-width: 88px !important;\n  }\n\n  .table th {\n    font-size: 10px !important;\n    font-weight: 600;\n  }\n\n  /* Actions / wide columns */\n  .table td:last-child,\n  .table th:last-child {\n    max-width: none !important;\n    min-width: 56px !important;\n  }\n\n  .table button {\n    min-width: 22px !important;\n    height: 22px !important;\n    padding: 0 3px !important;\n    font-size: 9px !important;\n  }\n\n  .table .chakra-stack {\n    gap: 3px !important;\n  }\n\n  .pagination {\n    margin: 8px 0 !important;\n    flex-wrap: wrap;\n    gap: 6px;\n    justify-content: center !important;\n  }\n\n  .paginationControls {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .paginationText {\n    font-size: 11px !important;\n    margin-right: 0 !important;\n    flex-shrink: 1;\n  }\n\n  .paginationNav {\n    gap: 4px !important;\n  }\n\n  .paginationNav .chakra-button {\n    min-width: 26px !important;\n    height: 26px !important;\n  }\n\n  .paginationInput :global(.chakra-numberinput) {\n    width: 52px !important;\n  }\n\n  .paginationInput {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n\n  .paginationSelect :global(select) {\n    width: 68px !important;\n    font-size: 11px !important;\n    height: 28px !important;\n    padding: 2px 4px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `SalesReportTable_tableWrapper__wssaZ`,
	"table": `SalesReportTable_table__iYgdZ`,
	"chakra-stack": `SalesReportTable_chakra-stack__wBudX`,
	"pagination": `SalesReportTable_pagination__pmM+k`,
	"paginationControls": `SalesReportTable_paginationControls__Z2YB4`,
	"paginationText": `SalesReportTable_paginationText__NLWud`,
	"paginationNav": `SalesReportTable_paginationNav__kOZX4`,
	"chakra-button": `SalesReportTable_chakra-button__Yw59W`,
	"paginationInput": `SalesReportTable_paginationInput__9OdTL`,
	"paginationSelect": `SalesReportTable_paginationSelect__TR457`
};
export default ___CSS_LOADER_EXPORT___;
